import React, { useMemo } from "react";
import DataTable from "../../../components/data-table";
import glassesService from "../../../services/glasses.service";
import { useSelector } from "react-redux";
import MoneyOffIcon from "@material-ui/icons/MoneyOff";
import SetDiscount from "./discount";
import { currencyFormat } from "../../../helpers";

const defaultKeys = [
  {
    title: "نام",
    field: "name",
    active: true,
  },
];

export default function GlassesStockPage() {
  const { initials } = useSelector((s) => s.app);
  const headerCells = useMemo(
    () => [
      {
        field: "glassesColor",
        title: "نام",
        mainField: true,
        disableSort: true,
        renderer: (glassesColor) => glassesColor.glasses.name,
      },
      {
        field: "glassesColor",
        title: "رنگ",
        disableSort: true,
        renderer: (glassesColor) => glassesColor.name,
      },
      {
        field: "glassesColor",
        title: "برند",
        disableSort: true,
        renderer: (glassesColor, _, extra) =>
          extra?.brands?.find((b) => b.id === glassesColor.glasses.brandId)
            ?.name || "",
      },
      {
        field: "glassesColor",
        title: "نوع",
        renderer: (glassesColor) =>
          initials?.enums?.glassCategory?.find(
            (i) => i.value === glassesColor.glasses.category
          )?.title || "",
        disableSort: true,
      },
      {
        field: "glassesColor",
        title: "جنسیت",
        disableSort: true,
        renderer: (glassesColor) =>
          initials?.enums?.gender?.find(
            (i) => i.value === glassesColor.glasses.gender
          )?.title || "",
      },
      {
        field: "glassesColor",
        title: "جنس",
        disableSort: true,
        renderer: (glassesColor) =>
          initials?.enums?.material?.find(
            (i) => i.value === glassesColor.glasses.material
          )?.title || "",
      },
      {
        field: "glassesColor",
        title: "شکل",
        disableSort: true,
        renderer: (glassesColor) =>
          initials?.enums?.shape?.find(
            (i) => i.value === glassesColor.glasses.shape
          )?.title || "",
      },
      {
        field: "lensSize",
        title: "طول لنز",
      },
      {
        field: "bridgeSize",
        title: "طول پل",
      },
      {
        field: "glassesColor",
        title: "وزن",
        disableSort: true,
        renderer: (glassesColor) => `${glassesColor.glasses.weight}g`,
      },
      {
        field: "glassesColor",
        title: "قیمت",
        renderer: (glassesColor) => currencyFormat(glassesColor.price),
        disableSort: true,
      },
      {
        field: "count",
        title: "موجودی",
      },
      {
        field: "glassesColor",
        title: "تخفیف",
        renderer: (glassesColor) => `${glassesColor.discount}%`,
        disableSort: true,
      },
      {
        field: "glassesColor",
        title: "وضعیت",
        renderer: (glassesColor) =>
          glassesColor.isActive ? "فعال" : "غیر فعال",
        disableSort: true,
      },
      // color: GlassesGeneralColor;
    ],
    [initials]
  );

  return (
    <div className="p-3">
      <DataTable
        backend={glassesService.getGlassesSizesUrl}
        headCells={headerCells}
        multiRowActions={[
          {
            icon: <MoneyOffIcon />,
            refreshOnClose: true,
            modalProps: { maxWidth: "sm" },
            modalContent: (props) => <SetDiscount {...props} />,
          },
        ]}
        searchKeys={defaultKeys}
        title="موجودی عینک‌ها"
        order={{ order: "ASC", orderBy: "count" }}
      />
    </div>
  );
}
